"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.load.error': '插槽数据加载失败',
};
